var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"draggableContainer",attrs:{"id":"draggable-container"}},[_vm._t("header"),_c('div',{attrs:{"id":"draggable-header"},on:{"mousedown":_vm.dragMouseDown}},[_vm._t("main")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }